import {UIData} from './Utils';
import TabsComponent from '../../sub-modules-menu/tabsComponent/TabsComponent';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {useAppContext} from '@context/AppContext';
import {getSearchForm} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {useSnackbar} from 'notistack';
import {useState, useEffect} from 'react';

interface AuditLogComponentProps {
  module: string;
  data: any;
}
const extractUrls = (data: any[]) => {
  let urls: {label: string; value: string}[] = [];

  data.forEach(
    (item: {
      name: string;
      url: string;
      hasListMenuItems: boolean;
      listMenuItems: any[];
    }) => {
      // Add the top-level module with name and url
      if (item.url) {
        urls.push({
          label: item.url,
          value: item.name
        });
      }

      // If item has listMenuItems, recursively extract urls from them
    }
  );

  return urls;
};

const AuditLogComponent = (props: AuditLogComponentProps): JSX.Element => {
  const {
    appState: {applicationName}
  } = useAppContext();
  const {enqueueSnackbar} = useSnackbar();
  const [tabData, setTabData] = useState({});
  const [loader, setLoader] = useState(false);
  const init = async () => {
    try {
      if (props.module) {
        setLoader(true);
        const res = await getSearchForm(applicationName, props.module);
        setTabData(res.searchForm);
        setLoader(false);
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoader(false);
    }
  };
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.module]);

  // Get all URLs from the jsonData
  const allUrls = extractUrls(props?.data.map((group: { items: any; }) => group.items).flat());
  return (
    <TabsComponent
      sectionUIData={tabData}
      user_access_module={allUrls}
      sectionRowsData={[]}
      module={props?.module}
      isLoading={loader}
    />
  );
};

export default AuditLogComponent;
